import { type IOrder } from '@/types/IOrder';
import { calculateTotalCostWithDelivery } from './calculateTotalCostWithDelivery';
import { formatCurrency } from './formatCurrency';
import { getImage } from './getImage';
import { getPaymentProviderColor } from './getPaymentProviderColor';
import { getPaymentProviderLabelPreview } from './getPaymentProviderLabelPreview';

export interface IOrderToastSummary {
  uuid: string;
  orderPath: string;
  title: string;
  recipientName: string | null;
  firstOfferName: string | null;
  offersCount: number;
  totalCost: string;
  imageSrc: string;
  paymentLabel: string;
  paymentColor: string;
}

const normalizeText = (value: string | null | undefined): string | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

/**
 * Готовит краткую сводку заказа для отображения в тосте: ссылку на заказ,
 * заголовок, имя получателя, первый товар, итоговую сумму, миниатюру товара
 * и способ оплаты. Чистая функция.
 *
 * @param order - заказ из события Mercure
 * @returns данные для карточки тоста
 */
export const getOrderToastSummary = (order: IOrder): IOrderToastSummary => {
  const totalCost = calculateTotalCostWithDelivery(
    order.orderOffers,
    order.delivery_amount
  );

  const firstOffer = order.orderOffers[0];

  return {
    uuid: order.uuid,
    orderPath: `/order/${order.uuid}`,
    title: normalizeText(order.formated_id) ?? `№ ${order.id}`,
    recipientName: normalizeText(order.orderRecipient?.name),
    firstOfferName: normalizeText(firstOffer?.offer?.name),
    offersCount: order.orderOffers.length,
    totalCost: formatCurrency(totalCost),
    // Миниатюра первого товара с дефолтной заглушкой (паттерн проекта getImage).
    imageSrc: getImage(firstOffer?.offer?.image ?? null),
    paymentLabel: getPaymentProviderLabelPreview(order.selectedPayment),
    paymentColor: getPaymentProviderColor(order.selectedPayment)
  };
};
